// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('jquery');
require('jquery-ui');
require('jquery-validation');
require('packs/common');
require('packs/work_order');
require('packs/preventive_maintences');
require('packs/parts');
require('packs/primary_assets');
require('packs/people');

import 'materialize-css/dist/js/materialize';
import $ from 'jquery';
import 'select2'
import 'select2/dist/css/select2.css'
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

require('chosen-js');

global.$ = jQuery;

function initializeSelect2() {
  $('.js-states').select2({
    placeholder: function(){
      return $(this).data('placeholder');
    },
    allowClear: false,
    width: '100%',
    theme: 'classic'
  });
}


window.addEventListener('DOMContentLoaded', () => {
  initializeSelect2();
})



// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
